import { render, staticRenderFns } from "./BaseSelector.vue?vue&type=template&id=ea8a0742&"
import script from "./BaseSelector.vue?vue&type=script&lang=ts&"
export * from "./BaseSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports